const HeaderSection = () => {
    return (
      <header>
        <img src="./Assets/icons/Spots-Logo.svg" alt="Spots Logo" />
      </header>
    );
  };
  
  export default HeaderSection;